import React, { Component } from 'react';

export class OfflinePlayerControls extends Component {

  constructor(props) {
      super(props);
      this.state = {
          
      };
    }

    getPhase() {
        return this.props.getPhaseFunc();
    }

    getCurrentHintTurn() {
        return this.props.getCurrentHintTurnFunc();
    }

    getBoardState() {
        return this.props.getBoardStateFunc();
    }

    getRemainingCounters() {
        return this.getBoardState().maxCounters - this.getBoardState().countersUsed;
    }

    getRemainingGreens() {
        return 15 - this.getBoardState().greenCount;
    }

    getPlayerClass() {
        if (this.props.player == 1) {
            return " offplayer1";
        }
        return "";
    }

    getStateTextForPlayer() {
        switch (this.getPhase()) {
            case "start": return "Waiting";
            case "guessing":
            case "settingColor":
                if (this.getCurrentHintTurn() == this.props.player) return "GIVE A HINT!";
                return "MAKE A GUESS";
            case "assassinated": return "ASSASSINATED";
            case "finished": return "SUCCEEDED! CONGRATS! :)";
            case "outofturns": return "Out of turns :(";
            default: return "Unknown";
        }
    }

    getButtonContent() {
        switch (this.getPhase()) {
            case "start":
                return (<button className={"btn btn-primary" + this.getPlayerClass()} onClick={() => this.props.giveHintFunc(this.props.player)}>GIVE A HINT</button>);
            case "finished":
            case "outofturns":
            case "assassinated":
                return (<button className={"btn btn-primary"} onClick={() => window.location.reload()}>New Game</button>);
            case "guessing":
                if (this.getCurrentHintTurn() != this.props.player) {
                    return (<button className={"btn btn-primary" + this.getPlayerClass()} onClick={() => this.props.concedeTurnAction()} disabled={this.props.isButtonDisabled}>QUIT GUESSING</button>);
                } else if (this.getBoardState().allGreensFinishedForPlayer == 0 && this.getBoardState().greenCount >= 9) {
                }
        }

        return "";
    }

    getRightButtonContent() {
        switch (this.getPhase()) {
            case "guessing":
                if (this.getBoardState().allGreensFinishedForPlayer == 0 && this.getBoardState().greenCount >= 9) {
                    return (<button className={"btn btn-primary" + this.getPlayerClass()} onClick={() => this.props.markAllGreensFinishedFunc(this.props.player)}>REPORT all greens finished on this side</button>);
                }
        }

        return "";
    }

    getRegularContent() {
        return (
            <div class="offlinePlayerControls">
                {this.getButtonContent()}
                <div><p className={this.getPlayerClass()}>Status: {this.getStateTextForPlayer(this.props.player)}</p>
                    <p>Turns left: {this.getRemainingCounters()}. Greens left: {this.getRemainingGreens()}</p></div>
                {this.getRightButtonContent()}
            </div>);
    }

    selectColor(color) {
        this.getBoardState().selectedCard.selectColor(color);
    }

    getSelectingColorContent() {
        return (
            <div id="offlinePlayerControls">
                <button className="btn offcardColorSelectButtonPlayer offblackcard" onClick={() => this.selectColor("black")}>BLACK</button>
                <button className="btn offcardColorSelectButtonPlayer offgreencard" onClick={() => this.selectColor("green")}>GREEN</button>
                <button className="btn offcardColorSelectButtonPlayer offyellowcard" onClick={() => this.selectColor("yellow")}>YELLOW</button>
            </div>);
    }

    render() {
        if (this.getPhase() === "settingColor" && this.getCurrentHintTurn() == this.props.player) {
            return this.getSelectingColorContent();
        } else {
            return this.getRegularContent();
        }
    }
}
